import { render, staticRenderFns } from "./view-removal-shipment-modal.vue?vue&type=template&id=0e062272&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./view-removal-shipment-modal.vue?vue&type=script&lang=js&"
export * from "./view-removal-shipment-modal.vue?vue&type=script&lang=js&"
import style0 from "./view-removal-shipment-modal.vue?vue&type=style&index=0&id=0e062272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e062272",
  null
  
)

export default component.exports